import { Extension } from '@tiptap/react';

export const RichSearchInputExtension = Extension.create({
  name: 'singleLine',

  addOptions() {
    return {
      commit: () => {}
    };
  },

  addKeyboardShortcuts() {
    return {
      Enter: () => {
        this.options.commit();
        return true;
      }, // Prevent default behavior
      'Ctrl-a': ({ editor }) => {
        // Move cursor to start
        editor.commands.setTextSelection(0);
        return true;
      },
      'Ctrl-e': ({ editor }) => {
        // Move cursor to end
        const docSize = editor.state.doc.content.size;
        editor.commands.setTextSelection(docSize);
        return true;
      }
    };
  }
});
